<template>
  <div class="progress-section">
    <div class="progress-bar">
      <div
        v-for="step in steps"
        :key="step"
        class="progress-step"
        :class="{ 'progress-step-active': step <= currentStep }"
        @click="() => changeStep(step)"
      ></div>
    </div>
    <span class="progress-text">{{ currentStep }}/3</span>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "PilgrimFormProgress",
  props: {
    currentStep: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  data() {
    return {
      totalSteps: 3,
    };
  },
  computed: {
    steps() {
      return Array.from({ length: this.totalSteps }, (_, index) => index + 1);
    },
  },
  methods: {
    changeStep(step) {
      if (this.currentStep < step) return;
      this.$emit("change:step", step);
    },
  },
});
</script>

<style scoped lang="scss">
.progress-section {
  @apply flex items-center gap-4;

  .progress-bar {
    @apply w-full flex gap-2;
    .progress-step {
      @apply h-2.5 w-full bg-zinc-200 rounded-full;
      &.progress-step-active {
        @apply bg-green-600;
      }
    }
  }

  .progress-text {
    @apply text-sm text-zinc-600 leading-5;
  }
}
</style>
